import React from "react";
import { Handshake, Map, Search } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const advantages = [{
  title: "Legally Compliant",
  description: "Our algorithms are strictly aligned with the latest Ontario Ministry of Finance guidelines and CRA tax regulations for total peace of mind.",
  icon: Handshake
}, {
  title: "Up-to-the-Minute Data",
  description: "Real-time updates on TFSA contribution limits and annual rent increase caps ensure your financial planning is always based on current law.",
  icon: Map
}, {
  title: "Privacy First",
  description: "We process your calculations locally. Your financial data is never stored on our servers, ensuring complete anonymity and security.",
  icon: Search
}];
export default function TheNeighborlyAdvantage() {
  return <section data-section-id="223484" id="why-accuracy-matters" className="w-full bg-background text-foreground py-20 md:py-28">
      <div className="container mx-auto px-4 md:px-6">
        <div className="rounded-lg bg-card px-6 py-16 md:px-12 md:py-20 lg:px-16 border border-border shadow-lg">
          <div className="mx-auto mb-16 max-w-2xl text-center">
            <h2 className="font-default text-3xl font-bold tracking-tighter text-foreground md:text-5xl uppercase">
              Why Accuracy Matters
            </h2>
            <p className="mt-4 text-lg font-default text-muted-foreground">
              Precision is the foundation of sound financial decisions. FINCALC delivers data you can trust.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            {advantages.map((item, i) => {
            const Icon = item.icon;
            return <Card key={i} data-index={i} className="group border border-border bg-background shadow-sm transition-all duration-200 hover:border-primary hover:shadow-xl rounded-md">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-md bg-primary/10 text-primary transition-transform duration-200 ease-out group-hover:scale-105">
                      <Icon className="h-8 w-8 stroke-[1.5]" />
                    </div>
                    <CardTitle className="font-default text-xl font-bold tracking-tight">
                      <h3>{item.title}</h3>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="leading-relaxed text-muted-foreground font-default text-sm">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </div>
    </section>;
}